import Backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import BuiltCampaignModel from "src/shared/campaigns/BuiltCampaignModel";
import CampaignCollection from "src/shared/campaigns/CampaignCollection";
import promiseService from "src/shared/promise-service";

const BuiltCampaignCollection = CampaignCollection.extend(
    {
        url: "/api/v2/campaigns/built",

        initialize(attributes, options) {
            this.campaignIds = options && options.campaignIds;
            this.filterModel = options?.filterModel;
        },

        fetch() {
            if (this.campaignIds) {
                const self = this;
                const deferred = $.Deferred();
                const promises = _.map(this.campaignIds, (campaignId) => {
                    const model = BuiltCampaignModel.create(campaignId);
                    return model.fetch.bind(model);
                });
                promiseService.promiseAll(promises).done((response) => {
                    self.reset(response, { silent: true });
                    return deferred.resolve();
                });
                return deferred;
            }

            return CampaignCollection.prototype.fetch.call(this);
        },
        getBuiltCampaignsByProgramLabel() {
            return Backbone.Collection.prototype.fetch
                .call(this, {
                    data: {
                        program_label: this.filterModel.get("program_label"),
                    },
                })
                .done((response) => {
                    return response;
                });
        },
    },
    {
        STATES: CampaignCollection.STATES,
    }
);

BuiltCampaignCollection.create = function (filterModel) {
    return new BuiltCampaignCollection(
        {},
        {
            filterModel: filterModel,
        }
    );
};

BuiltCampaignCollection.createForIds = function (campaignIds) {
    return new BuiltCampaignCollection(null, { campaignIds });
};

export default BuiltCampaignCollection;
